import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProgramaService } from '../services/programa.service';

@Injectable({
  providedIn: 'root'
})
export class ProgramaResolver implements Resolve<boolean> {

  constructor(private service: ProgramaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.idProjeto);
  }
}
